const USER_SET = 'USER_SET';
const UPDATE_KNOWLEDGE = 'UPDATE_KNOWLEDGE';

export default function user(state=null, action) {
  switch(action.type) {
    case USER_SET:
      return action.user
    case UPDATE_KNOWLEDGE:
      return {
        ...state,
        knowledge: {
          ...state.knowledge,
          ...action.topics
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js